import { Link, LinkProps } from 'Components/designSystem';
import React, { memo, MouseEvent, PropsWithChildren, useCallback } from 'react';
import { useHref, useLinkClickHandler } from 'react-router-dom';
import styled from 'styled-components';

interface RouterLinkProps extends LinkProps {
    /**
     * If `true` the navigation will replace the current entry in the history stack instead of adding a new one.
     */
    replace?: boolean;
}

function RouterLink(props: PropsWithChildren<RouterLinkProps>) {
    const { onClick, target, url = '#', children, replace, ...restProps } = props;

    const href = useHref(url);

    const changeRoute = useLinkClickHandler(url, {
        target,
        replace
    });

    const handleClick = useCallback((event: MouseEvent<HTMLAnchorElement>) => {
        if (onClick) {
            onClick(event);
        }

        if (!event.defaultPrevented) {
            changeRoute(event);
        }
    }, [ onClick, changeRoute ]);

    return (
        <StyledLink { ...restProps }
            url={ href }
            onClick={ handleClick }
            target={ target }
        >
            { children }
        </StyledLink>
    );
}

const StyledLink = styled(Link)`
    font-size: 14px;
    line-height: 20px;
`;

export default memo(RouterLink);
